export default __webpack_public_path__ + "static/media/B168.49aaca2d.png";